import { render, staticRenderFns } from "./MicrosoftIcon.vue?vue&type=template&id=6af8bf2a&scoped=true"
import script from "./MicrosoftIcon.vue?vue&type=script&lang=js"
export * from "./MicrosoftIcon.vue?vue&type=script&lang=js"
import style0 from "./MicrosoftIcon.vue?vue&type=style&index=0&id=6af8bf2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af8bf2a",
  null
  
)

export default component.exports